module.exports = __webpack_public_path__ + "img/thealbum.10b5c137.png";